export enum IdentityTypes {
    EndCustomer = 'EK',
    // Installer (customer)
    Installer = 'KuMA',
    // Employees
    ViInt = 'ViInt',
    ViExt = 'ViExt',
    ViAcc = 'ViAcc'
}
